import React, {useCallback} from 'react';
import {Box} from '@mui/material';
import {useDispatch, useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';

import FindMoreResults from '../find-more-results.jsx';
import {LoadMoreButton} from '@explorer/components/items-panel/item-components.jsx';
import {continueSearch} from '@explorer/actions/search';
import {getSelectedItemTypes} from '@explorer/selectors/item-types';
import {selectFilteredResultIds} from '@explorer/selectors/results';
import {trackEvent} from '@explorer/analytics';
import {updateStatus} from '@explorer/actions/results';

const ResultsListFooter = () => {
  const {t} = useTranslation();
  const dispatch = useDispatch();

  const resultsLoading = useSelector(state => state.results.loading);
  const resultsComplete = useSelector(state => state.results.complete);
  const onlySkySat = useSelector(state =>
    Object.keys(getSelectedItemTypes(state)).every(
      type => type.indexOf('SkySat') >= 0
    )
  );
  const resultsIdsCount = useSelector(
    state => selectFilteredResultIds(state).length
  );

  const loadMoreResults = useCallback(() => {
    trackEvent('Load More Results button clicked');
    dispatch(updateStatus(true));
    dispatch(continueSearch());
  }, [dispatch]);

  if (!resultsComplete) {
    return (
      <LoadMoreButton
        data-qe="load-more"
        disabled={resultsLoading}
        onClick={loadMoreResults}
      >
        {resultsLoading
          ? t('resultsList.loading', 'Loading...')
          : t('resultsList.loadMore', 'Load more')}
      </LoadMoreButton>
    );
  } else {
    const moreResultsMessage =
      resultsIdsCount === 0
        ? onlySkySat
          ? t('resultsList.lookingForHighRes', 'Looking for high res imagery?')
          : t('resultsList.noResults', 'Sorry, no results found')
        : onlySkySat
          ? t('resultsList.moreHighRes', 'Looking for more high res imagery?')
          : t('resultsList.moreResults', 'Looking for more results?');
    return (
      <Box display="flex" alignItems="center" my={2}>
        <FindMoreResults>{moreResultsMessage}</FindMoreResults>
      </Box>
    );
  }
};

export default ResultsListFooter;
